export default __webpack_public_path__ + "static/ether_case_webm-9f53accec7e3464ce6caa00696b9b3e4.webm";